import { TrackingServiceConfig } from '@type/tracking';
import {
  initializeTracking as initTracking,
  trackEvent as track,
  trackEventWithBeacon,
  getSessionId,
  getQueueLength,
  forceProcessQueue,
  resetTracking,
  clearTrackingSession,
} from './trackingService';


/** Export all types and functions from the tracking service. We don't export server tracking from here, there are problems with the '/pages' folder */
export * from '@type/tracking';
export { EVENTS_TRACKING_URL } from './constants';
export {
  initTracking as initializeTracking,
  track as trackEvent,
  trackEventWithBeacon,
  getSessionId,
  getQueueLength,
  forceProcessQueue,
  resetTracking,
  clearTrackingSession,
};

/**
 * @description Initialize the tracking service with the given endpoint and options.
 * To be used for creating a client-side tracking provider.
 * @param endpoint The endpoint URL for the tracking service.
 * @param options Optional configuration options for the tracking service.
 *
 * @example
 * export const TrackingProvider = ({ children }: TrackingProviderProps) => {
 *   useEffect(() => {
 *      // Add you tracking endpoint and options here or don't pass options to use default values
 *     initializeClientTracking('/api/tracking', {
 *        batchSize: 20,
 *        batchTimeout: 10000,
 *       debug: process.env.NODE_ENV === 'development',
 *     });
 *   }, []);
 *
 *   return <>{children}</>;
 * };
 */
export const initializeClientTracking = (endpoint: string, options = {}): void => {
  if (typeof window === 'undefined') return;

  const config: TrackingServiceConfig = {
    endpoint,
    ...options,
  };

  initTracking(config);
};
